<template>
<div>
<v-card>
    <v-card-title class="pb-0 justify-space-between" style="font-size:18px;">Option 1</v-card-title>
    <v-card-text class="pt-0">
         <v-layout>
            <v-flex class="pr-3">
               <v-text-field label="Option name TH" hide-details></v-text-field>
               <v-text-field label="Option name CN" hide-details></v-text-field>
            </v-flex>
            <v-flex>
            <v-text-field label="Option name EN" hide-details></v-text-field>
            </v-flex>
         </v-layout>
    </v-card-text>
    <v-layout row>
    <v-flex>
        <v-radio-group row class="mt-0 ml-3" hide-details>
            <div class="mr-2">Option Type : </div>
            <v-radio label="Single" value="single"></v-radio>
            <v-radio label="Multiple" value="multiple"></v-radio>
        </v-radio-group>
    </v-flex>
    <v-flex>
        <v-checkbox class="mt-0 ml-3" label="Required?" color="green" hide-details></v-checkbox>
    </v-flex>
    </v-layout>
    <v-card-text class="pt-0">
        <v-layout>
            <v-flex class="pr-3">
               <v-text-field label="Choice Name TH" hide-details></v-text-field> 
               <v-text-field label="Choice Name CN" hide-details></v-text-field>
            </v-flex>
            <v-flex>
            <v-text-field label="Choice Name EN" hide-details></v-text-field>
            <v-text-field label="Price" hide-details></v-text-field>
            </v-flex>
            <v-flex>
            <v-icon medium color="green" class="space-flex pl-4 pt-4">add_circle</v-icon>
            </v-flex>
        </v-layout>
        <!-- <hr class="mt-4"> -->
        <v-layout>
            <v-flex class="pr-3">
            <v-text-field label="Choice Name TH" hide-details></v-text-field> 
            <v-text-field label="Choice Name CN" hide-details></v-text-field>
            </v-flex>
            <v-flex>
            <v-text-field label="Choice Name EN" hide-details></v-text-field>
            <v-text-field label="Price" hide-details></v-text-field>
            </v-flex>
            <v-flex>
            <v-icon medium color="red" class="space-flex pl-4 pt-4">remove_circle</v-icon>
            </v-flex>
        </v-layout>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer> 
        <v-btn depressed>Cancel</v-btn>
        <v-btn depressed>Save</v-btn>
        <v-spacer></v-spacer> 
    </v-card-actions>
</v-card>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
